/* 
Uses functions and variables from asset files
- 'size-guide-functions.js'
*/

const options = document.getElementById('sizeBrandOptions');
const sizeBrandTitleWrapper = document.getElementById('sizeBrandTitleWrapper');

function loadTablesSizeGuidePage(brand) {
    let atLeastOneSizeChart = false;
    let sizeGuidePagesURL = {
        mens: `/pages/new-template-${brand}-mens-size-guide?view=blank`,
        womens: `/pages/new-template-${brand}-womens-size-guide?view=blank`,
        unisex: `/pages/new-template-${brand}-unisex-size-guide?view=blank`,
        kids: `/pages/new-template-${brand}-kids-size-guide?view=blank`,
    };

    Promise.all([fetch(sizeGuidePagesURL.mens), fetch(sizeGuidePagesURL.womens), fetch(sizeGuidePagesURL.unisex), fetch(sizeGuidePagesURL.kids)]) //Ajax call to get all the size pages.
        .then(function (responses) {
            return Promise.all(
                responses.map(function (response) {
                    if (response.ok) {
                        atLeastOneSizeChart = true;
                        return response.text();
                    }
                })
            );
        })
        .then((response) => {
            document.getElementById('loadingSizeTables').style.display = 'none';
            response.forEach(function (data, index) {
                try {
                    parseAndAppendTable(data, __sizeGuideContainersId[index], false);
                } catch {
                    console.log(`${__sizeGuideContainersId[index]} for ${brand} is unavailable.`);
                }
            });

            options.style.pointerEvents = "auto";
            return;
        });
}

options.addEventListener('change', function () {
    options.style.pointerEvents = "none";
    resetCollapsibleTables();

    document.getElementById('loadingSizeTables').style.display = 'block';

    let brandTitle = this[this.selectedIndex].value;
    let brandLogo = this[this.selectedIndex].getAttribute('data-brand-logo');
    let brandUrl = this[this.selectedIndex].getAttribute('data-brand-collection');
    let brandHandle = this[this.selectedIndex].getAttribute('data-brand-handle');

    document.querySelectorAll('.is-available').forEach(function (e) {//Resets all the tables with 'is-available' class to 'is-unavailable'
        if (e.classList.contains('is-available')) {
            e.classList.remove('is-available');
            e.classList.add('is-unavailable');
        }
    });

    __sizeGuideContainersId.forEach((e) => document.querySelectorAll(`#${e} .size_chart_table`)[0].innerHTML = '');//Clears the container in which tables load

    sizeBrandTitleWrapper.innerHTML = ''; //Clears the image container
    sizeBrandTitleWrapper.innerHTML = brandLogo !== '' ? `<img title="Shop ${brandTitle}" alt="${brandTitle} Logo" class="size-brand-title-image" src="${brandLogo}">` : `<span class="size-brand-title-link">${brandTitle}</span>`;
    sizeBrandTitleWrapper.setAttribute("href", brandUrl);

    loadTablesSizeGuidePage(brandHandle);
})

triggerCollapsibleTables();//Fnc in size-guide-functions.js file